import React from "react";
import ReactDOM from "react-dom";
import { BsyUtils } from "../../utils/Utils";
import AlertList from "./Staticize";

const BsyAlertMenu = (props) =>
  new Promise((fulfill) => {
    // 此处参数需用圆括号，否则 eslint 报错
    let holder;
    if (document.getElementsByClassName("BsyAlertMenu").length > 0) {
      document.getElementsByClassName("BsyAlertMenu")[0].remove();
    }
    let rootTokenClass = "rootTokenCls" + new Date().getTime();
    holder = document.createElement("div");
    holder.classList.add("BsyAlertMenu");
    holder.classList.add(rootTokenClass);
    if (props.theme) {
      holder.classList.add(props.theme);
    }
    let top = 0;
    let left = 0;
    let target = null;
    if (props.target) {
      target = props.target;
      let jj = BsyUtils.elemoffset(target);
      left = jj.left;
      top = jj.top;
    } else {
      if (props.position) {
        left = props.position.left;
        top = props.position.top;
      }
      target = { offsetWidth: 10, offsetHeight: 10 };
    }

    let ddheight = props.height;

    if (!props.height || props.height === "auto") {
      ddheight = props.item.length * 36 + 20;
      ddheight = ddheight + props.item.filter(item => item.line).length * 22
      if (ddheight > 360) {
        ddheight = 360;
      }
    }

    let css = {};
    if (props.position === "bottom") {
      css = {
        left:
          left + props.width + target.offsetWidth >
            document.documentElement.clientWidth
            ? left - props.width + target.offsetWidth
            : left,
        width: props.width,
        // height: ddheight ? ddheight : "auto",
        maxHeight:
          document.documentElement.clientHeight -
          top -
          target.offsetHeight -
          10,
        top: top + target.offsetHeight + 2,
      };
    } else {
      if (
        ddheight >
        document.documentElement.clientHeight - top - target.offsetHeight - 10
      ) {
        css = {
          left:
            left + props.width + target.offsetWidth >
              document.documentElement.clientWidth
              ? left - props.width + target.offsetWidth
              : left,
          width: props.width,
          // height: ddheight ? ddheight : "auto",
          // maxHeight: top - 10,
          bottom: document.documentElement.clientHeight - top + 2,
        };
      } else {
        css = {
          left:
            left + props.width + target.offsetWidth >
              document.documentElement.clientWidth
              ? left - props.width + target.offsetWidth
              : left,
          width: props.width,
          // height: ddheight ? ddheight : "auto",
          maxHeight:
            document.documentElement.clientHeight -
            top -
            target.offsetHeight -
            10,
          top: top + target.offsetHeight + 2,
        };
      }
    }

    // ddheight > (document.documentElement.clientHeight - top - target.offsetHeight - 10) ? {
    //     left: left + props.width + target.offsetWidth > document.documentElement.clientWidth ? left - props.width + target.offsetWidth : left,
    //     width: props.width,
    //     height: props.height ? props.height : 'auto',
    //     bottom: document.documentElement.clientHeight - top + 2
    // } : {
    //     left: left + props.width + target.offsetWidth > document.documentElement.clientWidth ? left - props.width + target.offsetWidth : left,
    //     width: props.width,
    //     height: props.height ? props.height : 'auto',
    //     top: top + target.offsetHeight + 2
    // }

    holder.style.zIndex = window.FX.STATIC.zIndex++;
    holder.style.left = css.left + "px";
    holder.style.width = css.width + "px";
    holder.style.maxHeight = css.maxHeight + "px";
    holder.style.height =
      css.height === "auto" ? css.height : css.height + "px";
    holder.style.bottom = css.bottom ? css.bottom + "px" : "auto";
    holder.style.top = css.top ? css.top + "px" : "auto";
    window.mode && holder.classList.add(window.mode);
    if (props.renderEl) {
      props.renderEl.appendChild(holder);
    } else {
      document.body.appendChild(holder);
    }

    let holderTo = document.createElement("div");
    holderTo.classList.add("alertMenuContent");
    holder.classList.add("fadein");
    if (props.onMouseLeave) {
      holderTo.addEventListener(
        "mouseleave",
        () => {
          if (props.onMouseLeave) {
            props.onMouseLeave();
          }
        },
        false
      );
    }

    setTimeout(() => {
      holder.classList.add("active");
    }, 30);

    holder.onclick = (event) => {
      event.stopPropagation();
    };
    holder.appendChild(holderTo);

    let CleanRootNode = (e) => {
      // 当界面被点击时自动清理元素
      // e 为null，组件自己清理自己
      // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
      if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
        holder && holder.classList.remove("active");
        setTimeout(() => {
          holder && holder.classList.remove("fadein");
          holder && holder.remove();
        }, 60);
        props.onClose && props.onClose(e);
        document.removeEventListener("mouseup", CleanRootNode, false);
      }
    };
    document.addEventListener("mouseup", CleanRootNode, false);

    if (document.getElementsByClassName("alertMenuContent").length > 1) {
      ReactDOM.unmountComponentAtNode(holderTo);
      holder.removeChild(holderTo);
      // clearInterval(timer)
    }
    const newProps = { ...props, target: holderTo };
    newProps.onRemoveRoot = () => {
      //自动清理
      CleanRootNode();
    };
    ReactDOM.render(<AlertList {...newProps} />, holderTo);
  }).catch((res) => {
    console.error("BsyAlertMenu", res);
  });

export default BsyAlertMenu;
